
<!-- <div class="zoomI"> -->
  <mat-stepper

  [linear]="true" #stepper
    class="example-stepper"
    [orientation]="(stepperOrientation | async)!">
    
    <mat-step [stepControl]="firstFormGroup" label=" Select City , Rooms & Guests">
        <form [formGroup]="firstFormGroup">
            <!-- <div *ngIf="pending" class="d-flex justify-content-start" >
                <img src="../../../assets/images/time.gif" style="height:200px;border-radius: 4px;" alt="">
                  </div> -->
          
        
        <span >
        <!-- <div  class="mt-2  col-md-12 d-flex justify-content-start" style="padding-left:12px ;">

            <div class="col-md-12 border " style="border-radius: 4px; padding: 4px;background-color: white;">
             
          <form   class=" d-flex justify-content-start" >
            <mat-radio-group  color="primary" [(ngModel)]="type" (change)="onDOMINTChange()" [ngModelOptions]="{standalone: true}">
                <mat-radio-button  value="D">Domestic</mat-radio-button>
                <mat-radio-button *ngIf="!pendingINT"  value="I">International</mat-radio-button>
                <img *ngIf="pendingINT" src="../../../assets/images/time.gif" style="height:40px;border-radius: 4px; margin-left: 2rem;" alt="">

              </mat-radio-group>
              
             
        </form></div></div> -->
        <div  class="mt-2 mb-2  col-md-12 d-flex justify-content-start" style="padding-left:12px ;">
       <div class="col-md-12 row">
        <div   class=" col-md-4 row"  >
          <div  class="col-md-12 ">                                  
            <label style="color: #666666;text-align: left;" >Select City *</label>
            <div class="d-flex justify-content-start">
            <app-drop-down style="flex: 1;text-align: left;" name="filterBranch" [modelInput]="addresstextValue" [ngModelOptions]="{standalone: true}"
            [params]="branchFilterParams"  (onSelectItem) = "invokeEventss($event)" (onInput)="onInput($event)" [list]="suggestions"> 
        </app-drop-down>  
      </div>
            <!-- <div class="input-group" >
              <span class="input-group-addon">
                <i class="fa fa-map-marker"></i>
              </span>
              <input
              matInput
                #addresstextInput
                type="text"
                placeholder="Search location"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="addresstextValue"
                
                style="outline: none; border: none; border-bottom: 1px solid #757575;border-radius: 0;width: 100%;"
              />
            </div> -->
        
        </div>
            <!-- <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>City, Property Name Or Location</mat-label>
                <mat-select-trigger (click)="autoCity.open()">
                  <input (input)="autoCity.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
                </mat-select-trigger>
                <mat-select matNativeControl #autoCity="matSelect"   (selectionChange)="onChangeCity()" formControlName="cityData"   name="entity"  >
                  <mat-option *ngFor="let item of filteredEntities"     [value]="{city:item?.cityName,country:item?.countryCode}" >{{item?.cityLabel}} {{item?.countryCode}} </mat-option>
                </mat-select>
        
              </mat-form-field>  -->
              <mat-form-field class="col-md-6 " appearance="outline">
                <input matInput readonly  [matDatepicker]="CheckIn"  formControlName="checkIn" >
                <mat-label> Check-In</mat-label>
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="CheckIn"></mat-datepicker-toggle>
                <mat-datepicker #CheckIn></mat-datepicker>
            </mat-form-field>
            <mat-form-field   class="col-md-6 " appearance="outline">
              <mat-label>Check-In Time</mat-label>
              <input  matInput readonly [ngxTimepicker]="checkInTime"  placeholder="HH:MM AM/PM" formControlName="checkInTime">
              <button mat-icon-button matSuffix (click)="checkInTime.open()">
                  <mat-icon>watch_later</mat-icon>
              </button> 
                
              <ngx-material-timepicker #checkInTime></ngx-material-timepicker>
            </mat-form-field>
            <mat-form-field class="col-md-6 " appearance="outline">
                <input matInput readonly  [matDatepicker]="CheckOut" [min]="firstFormGroup.value.checkIn"  formControlName="checkOut" >
                <mat-label>Check-Out</mat-label>
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="CheckOut"></mat-datepicker-toggle>
                <mat-datepicker #CheckOut></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-6"  appearance="outline">
              <mat-label>Check-Out Time</mat-label>
              <input  matInput readonly [ngxTimepicker]="checkOutTime" placeholder="HH:MM AM/PM" formControlName="checkOutTime">
              <button mat-icon-button matSuffix (click)="checkOutTime.open()">
                  <mat-icon>watch_later</mat-icon>
              </button> 
                
              <ngx-material-timepicker #checkOutTime></ngx-material-timepicker>
            </mat-form-field>
              
        </div>
       
           
        <div   class=" col-md-3"  >
          <mat-form-field  class="col-md-12 mt-1" style="height: 80px;" appearance="outline">
            <mat-label>Source</mat-label>
           
            <mat-select matNativeControl   formControlName="source"   name="source" (selectionChange)="getSupplierlist($event)" >
              <mat-option   class="mat-primary" *ngFor="let list of  sourceList"  [value]="list.code" >{{list?.name}} </mat-option>
            </mat-select>
    
          </mat-form-field> 
          <mat-form-field  class="col-md-12"  appearance="outline">
            <mat-label>Supplier</mat-label>
           
            <mat-select matNativeControl   formControlName="supplier"   name="supplier"  >
              <mat-option   class="mat-primary" *ngFor="let list of  supplierList"  [value]="list.code" >{{list?.name}} </mat-option>
            </mat-select>
    
          </mat-form-field> 
              <!-- <mat-form-field   class="col-md-12" style="margin-top: 6px;" appearance="outline">
                <mat-label>Check-In Time</mat-label>
                <input  matInput readonly [ngxTimepicker]="checkInTime"  placeholder="HH:MM AM/PM" formControlName="checkInTime">
                <button mat-icon-button matSuffix (click)="checkInTime.open()">
                    <mat-icon>watch_later</mat-icon>
                </button> 
                  
                <ngx-material-timepicker #checkInTime></ngx-material-timepicker>
              </mat-form-field>
              <mat-form-field class="col-md-12"  style="margin-top: 8px;" appearance="outline">
                <mat-label>Check-Out Time</mat-label>
                <input  matInput readonly [ngxTimepicker]="checkOutTime" placeholder="HH:MM AM/PM" formControlName="checkOutTime">
                <button mat-icon-button matSuffix (click)="checkOutTime.open()">
                    <mat-icon>watch_later</mat-icon>
                </button> 
                  
                <ngx-material-timepicker #checkOutTime></ngx-material-timepicker>
              </mat-form-field> -->
        </div>
        <div   class="row col-md-5"  >

        <div class=" col-md-12 room-selection">
            <!-- <h3>Select Rooms</h3> -->
            <!-- Room count dropdown -->
            
            <div class="col-md-12 row">
              <label class="col-md-6 pt-2" for="roomCount">Rooms:</label>
             <div class="col-md-5 styled-select m-1">
              <select   [(ngModel)]="roomCount" [ngModelOptions]="{standalone: true}"   (change)="onRoomCountChange()">
                <option *ngFor="let count of roomOptions" [value]="count">{{ count }}</option>
              </select>
            </div>
            </div>
          
            <!-- Room details for each selected room -->
            <div *ngFor="let room of roomss; let i = index" class="room-details">
                <div class="col-md-12 row">
                    <label class="col-md-6 pt-2 roomLabel" for="Room-{{i+1}}">Room {{ i + 1 }}</label>

              <!-- <h6 class="d-flex justify-content-start">Room {{ i + 1 }}</h6> -->
              </div>
              <!-- Number of adults -->
              <div class="col-md-12 row">
                <label class="col-md-6 pt-2" for="adults-{{i}}">Adults:</label>
                <div class="col-md-5 styled-select" >
                <select  [(ngModel)]="room.adults" [ngModelOptions]="{standalone: true}"  id="adults-{{i}}" (change)="onAdultChange()">
                  <option *ngFor="let count of adultOptions"  [value]="count">{{ count }}</option>
                </select>
                </div>
                <!-- <input type="number" [(ngModel)]="room.adults" id="adults-{{i}}" min="1" /> -->
              </div>
          
              <!-- Number of children -->
              <div class="col-md-12 row pt-2 pb-2">
                <label class="col-md-6 " for="children-{{i}}">Children: <br>
                  <small style="color: gray; font-size: 10px;">0 - 11 Years Old</small>

                </label>
                
                <!-- <input type="number" [(ngModel)]="room.childrenCount" id="children-{{i}}" min="0" (input)="onChildrenCountChange(i)" /> -->
               <div class="col-md-5 styled-select" >
                <select [(ngModel)]="room.childrenCount" [ngModelOptions]="{standalone: true}"  id="children-{{i}}" (change)="onChildrenCountChange(i)">
                  <option *ngFor="let count of childOptions" [value]="count">{{ count }}</option>
                </select>
              </div>
              </div>
          
              <!-- Children's ages -->
              <div class="col-md-12 row" *ngIf="room.childrenCount > 0" >
                <!-- <h5>Children's Ages</h5> -->
                <div class="col-md-6" *ngFor="let age of room.childrenAges; let j = index">
                  <label for="child-age-{{i}}-{{j}}">Child {{ j + 1 }} Age:</label>
                  <div class="styled-select">
                  <select [(ngModel)]="room.childrenAges[j]" [ngModelOptions]="{standalone: true}"  id="child-age-{{i}}-{{j}}" >
                    <option *ngFor="let count of childAgeOptions" [value]="count">{{ count }}</option>
                  </select>
                </div>
                  <!-- <input type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="room.childrenAges[j]" id="child-age-{{i}}-{{j}}" min="0" max="11" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      
        </div>
        <div class="d-flex justify-content-end " style="padding-right: 55px;" >
            <button  mat-flat-button style="background-color:#417ACF ;color: #fff;" matStepperNext>Continue</button>
          </div>
        </span>
      <!-- <form [formGroup]="firstFormGroup">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form> -->
     
    </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label="Hotel Details">
      <form [formGroup]="secondFormGroup">
        <div  class="mt-2  col-md-12 d-flex justify-content-start" style="padding-left:12px ;">
            <div class="col-md-12 row">
            <mat-form-field  class="col-md-8" appearance="outline">
                <mat-label>Hotel Name</mat-label>
                <input matInput  name='hotelName' formControlName="hotelName" >
               
              </mat-form-field>
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Booking Id <span style="color: red;font-size: small;">( No special characters allowed )</span></mat-label>
                <input matInput maxlength="20" (keypress)="alphaNumericOnly($event)"  name='bookingId' formControlName="bookingId" >
               
              </mat-form-field>
              
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Address</mat-label>
                <input matInput  name='address' formControlName="address" >

              </mat-form-field>  
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Star Rating</mat-label>
                <mat-select    matNativeControl  formControlName="star"   name="star"  >
                    <mat-option value="1">1</mat-option>
                    <mat-option value="2">2</mat-option>
                    <mat-option value="3">3</mat-option>
                    <mat-option value="4">4</mat-option>
                    <mat-option value="5">5</mat-option>

                  </mat-select>
              </mat-form-field>
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Pin Code</mat-label>
                <input matInput  name='pinCode'maxlength="6" (keypress)="onlyNumberKey($event)" formControlName="pinCode" >

              </mat-form-field>    
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Amenities</mat-label>
                <mat-select  multiple  matNativeControl  formControlName="mmtAmenities"   name="mmtAmenities"  >
                    <mat-option *ngFor="let amenities of mmtAmenities" [value]="amenities">{{amenities.displayName}}</mat-option>
                    

                  </mat-select>
              </mat-form-field>
            
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Description</mat-label>
                <textarea matInput  name='description' maxlength="250"   formControlName="description" ></textarea>

              </mat-form-field>
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Hotel Contact Number</mat-label>
                <input matInput (keypress)="onlyNumberKey($event)" name='contactNumber' formControlName="contactNumber" >
               
              </mat-form-field>
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Hotel Contact Email</mat-label>
                <input matInput  name='contactEmail' formControlName="contactEmail" >
               
              </mat-form-field>
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Room Type</mat-label>
                <input matInput  name='roomType' formControlName="roomType" >
               
              </mat-form-field>
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Meal Type</mat-label>
                <mat-select    matNativeControl  formControlName="mealType"   name="mealType"  >
                  <mat-option value="All Inclusive">All Inclusive</mat-option>
                    <mat-option value="Room with Breakfast">Room with Breakfast</mat-option>
                    <mat-option value="Room Only">Room Only</mat-option>
                    <mat-option value="Room with Breakfast + Dinner">Room with Breakfast + Dinner</mat-option>
                    <mat-option value="Room with Breakfast + Lunch/Dinner">Room with Breakfast + Lunch/Dinner</mat-option>
                    <mat-option value="Room With Breakfast + Lunch + Dinner">Room With Breakfast + Lunch + Dinner</mat-option>

                  </mat-select>
              </mat-form-field>  
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Inclusions</mat-label>
                <input matInput  name='inclusions' formControlName="inclusions" >

              </mat-form-field>  
              
        </div>
        </div>
        <div>
            <div class="d-flex justify-content-end" style="padding-right: 40px;" >
                <button  mat-flat-button style="background-color:#417ACF ;color: #fff;margin-right: 10px;" matStepperPrevious>Back</button>

                <button  mat-flat-button style="background-color:#417ACF ;color: #fff;" (click)="checkValidateBookingId(stepper)" matStepperNext>Continue</button>
              </div>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup" label="Fare Detail">
      <form [formGroup]="thirdFormGroup">
        <div  class="mt-2  col-md-12 d-flex justify-content-start" style="padding-left:12px ;">
            <div class="col-md-12 row">
             
            
<div class="d-flex justify-content-start mb-1">
  <label style="font-size:x-large;"  id="example-radio-group-label" class="pt-1">Payment Booking Type : </label><br>
  <mat-radio-group 
  formControlName="bookingPaymentType"
  class="custom-radio-group"
>
  <mat-radio-button value="R" color="primary" class="custom-radio-button">Prepaid</mat-radio-button>
  <mat-radio-button value="S" color="primary" class="custom-radio-button">Postpaid</mat-radio-button>
</mat-radio-group>
</div>
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Base Fare </mat-label>
                <input matInput (keypress)="onlyNumberKey($event)" name='baseFare' formControlName="baseFare" >

              </mat-form-field>  
              <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Taxes & fees	 </mat-label>
                <input matInput (keypress)="onlyNumberKey($event)" name='taxes' formControlName="taxes" >

              </mat-form-field>
              
        </div>
        </div>
        <div>
            <div class="d-flex justify-content-end" style="padding-right: 40px;" >
                <button  mat-flat-button style="background-color:#417ACF ;color: #fff;margin-right: 10px;" matStepperPrevious>Back</button>

                <button  mat-flat-button style="background-color:#417ACF ;color: #fff;" matStepperNext (click)="CreateCart(stepper)" >Create Cart</button>
              </div>
        </div>
      </form>
    </mat-step>
    <!-- <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <p>You are now done.</p>
      <div>
        <button mat-button matStepperPrevious>Back</button>
      </div>
    </mat-step> -->
  </mat-stepper>
    
    <!-- <div class="container">
        <div class="form-section">
            <div class="grid">
                <div>
                    <label>Type</label>
                    <div class="radio-group">
                        <label><input type="radio" name="type">Domestic</label>
                        <label><input type="radio" name="type">International</label>
                    </div>
                </div>
                <div>
                    <label>Booking Type</label>
                    <div class="radio-group">
                        <label><input type="radio" name="booking_type">Hotel</label>
                        <label><input type="radio" name="booking_type">Package</label>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div>
                    <label>City</label>
                    <input type="text">
                </div>
                <div>
                    <label>OR Enter any other Location of Hotel:</label>
                    <input type="text">
                </div>
                <div>
                    <label>Enter :</label>
                    <input type="text">
                </div>
                <div>
                    <label>Nationality</label>
                    <select>
                        <option>India</option>
                    </select>
                </div>
                <div>
                    <label>Location</label>
                    <input type="text">
                </div>
                <div>
                    <label>Additional Notes</label>
                    <input type="text">
                </div>
                <div>
                    <label>Check-In</label>
                    <div class="grid-3">
                        <input type="text" value="27/02/2025">
                        <select>
                            <option>14</option>
                        </select>
                        <select>
                            <option>0</option>
                        </select>
                    </div>
                </div>
                <div>
                    <label>Check-Out</label>
                    <div class="grid-3">
                        <input type="text" value="28/02/2025">
                        <select>
                            <option>12</option>
                        </select>
                        <select>
                            <option>0</option>
                        </select>
                    </div>
                </div>
            </div>
            <div>
                <label>Hotel Star Rating</label>
                <select>
                    <option>0</option>
                </select>
            </div>
            <div>
                <label>Hotel Category</label>
                <select>
                    <option>Hotels</option>
                </select>
            </div>
            <div>
                <label>Preferred Hotels</label>
                <input type="text">
                <input type="text">
                <input type="text">
            </div>
            <div>
                <label>Budget</label>
                <input type="text">
            </div>
            <div>
                <label>Description</label>
                <textarea></textarea>
            </div>
            <div>
                <label>Rooms</label>
                <select>
                    <option>1</option>
                </select>
            </div>
            <div class="form-section">
                <div class="grid-6">
                    <div>
                        <label>Room</label>
                        <input type="text" value="1">
                    </div>
                    <div>
                        <label>Room Type</label>
                        <input type="text">
                    </div>
                    <div>
                        <label>Inclusions</label>
                        <input type="text">
                    </div>
                    <div>
                        <label>Adults</label>
                        <select>
                            <option>1</option>
                        </select>
                    </div>
                    <div>
                        <label>Children</label>
                        <select>
                            <option>0</option>
                        </select>
                    </div>
                </div>
                <div class="grid">
                    <div>
                        <label>Amenities</label>
                        <div class="checkbox-group">
                            <label><input type="checkbox">Bar</label>
                            <label><input type="checkbox">Business Centre</label>
                            <label><input type="checkbox">Gym</label>
                            <label><input type="checkbox">Swimming Pool</label>
                        </div>
                    </div>
                    <div>
                        <label>Special Request</label>
                        <div class="checkbox-group">
                            <label><input type="checkbox">Extra Bed Adult</label>
                            <label><input type="checkbox">Extra Bed Child with bed</label>
                            <label><input type="checkbox">Extra Bed Child without bed</label>
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div>
                        <label>Passenger</label>
                        <input type="text">
                    </div>
                    <div>
                        <label>Room</label>
                        <select>
                            <option>Room 1</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>Primary Passenger Information for Rooms</h2>
                <div class="grid-3">
                    <div>
                        <label>Room</label>
                        <input type="text" value="1">
                    </div>
                    <div>
                        <label>Title</label>
                        <select>
                            <option>--</option>
                        </select>
                    </div>
                    <div>
                        <label>First Name</label>
                        <input type="text">
                    </div>
                    <div>
                        <label>Last Name</label>
                        <input type="text">
                    </div>
                </div>
                <div>
                    <label><input type="checkbox">Select to enter secondary passenger info.</label>
                </div>
            </div>
            <div class="button-group">
                <button>Create Cart</button>
            </div>
        </div>
    </div> -->
